export default "__VITE_ASSET__CvztCqKk__"